import React from "react";

import {
  ChatRounded,
  DirectionsBusRounded,
  EditNoteRounded,
  ExpandMoreRounded,
  FlightClassRounded,
  RestaurantRounded,
} from "@mui/icons-material";
import { Box, Chip, Collapse, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { GreyPallet } from "../../../../../config/styles";

import MainText from "../../../../../components/MainText";
import { CustomBox, StyledChip } from "../../../../../components/StyledComponents";

import ExpandMore from "../../../../../components/ExpandMore";
import { BusScheduleInfoType } from "../../../../../types/bus";
import ModalWriteSchedule from "../ModalWriteSchedule";

type BannerItemProps = {
  id: string;
  item: BusScheduleInfoType;
  handleReload: () => void;
};

export default function ScheduleItem({ id, item, handleReload }: BannerItemProps) {
  const navigate = useNavigate();

  const [showModalWrite, setShowModalWrite] = React.useState(false);
  const [showContent, setShowContent] = React.useState(false);

  const onCloseModalHandler = (reload?: boolean) => {
    setShowModalWrite(false);
    if (reload) handleReload();
  };

  //

  return (
    <>
      {showModalWrite && (
        <ModalWriteSchedule onClose={onCloseModalHandler} schedule={item} id={id} />
      )}

      <CustomBox key={id}>
        <Box mt={1} mb={2} display={"flex"} justifyContent={"space-between"}>
          <Box gap={1} display={"flex"} flexDirection={"column"} flexWrap={"wrap"}>
            <StyledChip chipcolor={item.color} label={id} />
            <Chip icon={<DirectionsBusRounded />} label={item.name} />
            <Chip icon={<FlightClassRounded />} label={item.shortName} />
          </Box>

          <Box gap={1} display={"flex"}>
            <IconButton onClick={() => setShowModalWrite(true)}>
              <EditNoteRounded />
            </IconButton>
            <ExpandMore
              expand={showContent}
              onClick={() => setShowContent(!showContent)}
              aria-expanded={showContent}
            >
              <ExpandMoreRounded />
            </ExpandMore>
          </Box>
        </Box>

        <Collapse in={showContent} timeout="auto" unmountOnExit={true} sx={{ overflow: "hidden" }}>
          <Box display={"flex"} justifyContent={"center"} gap={1} flexWrap={"wrap"}>
            {Object.keys(item.schedule).map((hour) =>
              Object.keys(item.schedule[hour]).map((minute, index) => (
                <Box
                  key={`${hour}-${minute}-${index}`}
                  sx={{
                    border: "2px solid " + GreyPallet.Regular,
                    borderRadius: "10px",
                    color: GreyPallet.Regular,
                    px: 2,
                    py: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <MainText size="body" color="regular">
                    {`0${hour}`.slice(-2)}:{`0${minute}`.slice(-2)}
                  </MainText>
                  {!!item.schedule[hour][minute].ru && <RestaurantRounded fontSize="small" />}
                  {!!item.schedule[hour][minute].terminal && (
                    <DirectionsBusRounded fontSize="small" />
                  )}
                  {!!item.schedule[hour][minute].company && <ChatRounded fontSize="small" />}
                </Box>
              ))
            )}
          </Box>
        </Collapse>
      </CustomBox>
    </>
  );
}
